import { createFileRoute } from "@tanstack/react-router"
import DesignSystemStatTile from "~/pages/design-system/components/StatTile"

export const Route = createFileRoute("/_auth/internal/design-system/components/stat-tile")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemStatTile />
}
